import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kp-confirm-team-ownership-change-dialog',
  template: `<h1 mat-dialog-title>Transfer Ownership</h1>
    <mat-dialog-content>
      <p>Are you sure you want to transfer ownership to {{ data.name }} ({{ data.email }})?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button
        class="secondary-action-button"
        mat-button
        [attr.aria-label]="'Cancel - do not transfer ownership to ' + data.name"
        (click)="onCancel()">
        Cancel
      </button>
      <button
        class="primary-action-button"
        mat-button
        color="primary"
        [attr.aria-label]="'Accept - transfer ownership to ' + data.name"
        (click)="onConfirm()">
        Accept
      </button>
    </mat-dialog-actions>`,
})
export class ConfirmTeamOwnershipChangeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmTeamOwnershipChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
